import { render, staticRenderFns } from "./validating-panel-placeholder.vue?vue&type=template&id=7977f4da&scoped=true&"
import script from "./validating-panel-placeholder.vue?vue&type=script&lang=ts&"
export * from "./validating-panel-placeholder.vue?vue&type=script&lang=ts&"
import style0 from "./validating-panel-placeholder.vue?vue&type=style&index=0&id=7977f4da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7977f4da",
  null
  
)

export default component.exports